import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";

/** Editor layout: wide main column + settings sidebar (stacks on small screens). */
export function SplitLayout({ main, aside }: { main: ReactNode; aside: ReactNode }) {
  return (
    <div className="split">
      <div className="stack gap-lg min-w-0">{main}</div>
      <aside className="stack gap-md split-aside">{aside}</aside>
    </div>
  );
}

/** Responsive grid: two-up / three-up cards, or stat tiles. */
export function Grid({ cols = "2", children, className }: { cols?: "2" | "3" | "stats"; children: ReactNode; className?: string }) {
  return <div className={cx("grid", `grid-${cols}`, className)}>{children}</div>;
}

/** Vertical rhythm between page sections. */
export function Stack({ gap = "md", children, className }: { gap?: "xs" | "sm" | "md" | "lg"; children: ReactNode; className?: string }) {
  return <div className={cx("stack", `gap-${gap}`, className)}>{children}</div>;
}

/** Filter bar above a list: sits flush on top of a table inside a <Card flush>. */
export function Toolbar({ children, end, plain }: { children: ReactNode; end?: ReactNode; plain?: boolean }) {
  return (
    <div className={cx("toolbar", plain && "toolbar-plain")} role="search">
      {children}
      {end && <><span className="spacer" />{end}</>}
    </div>
  );
}

/** Labelled group of fields inside a form (separated by a dashed rule). */
export function FormSection({ title, children }: { title?: ReactNode; children: ReactNode }) {
  return (
    <div className="form-section">
      {title && <div className="form-section-title">{title}</div>}
      {children}
    </div>
  );
}
